import React, { useRef, useEffect } from "react";
import "./GeneratePage.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import Cookies from "js-cookie";

function GeneratePage(props) {
  let userId = props.userId;
  let buttonRef = useRef(null);
  let promptRef = useRef();
  let boxRef = useRef();

  async function updateLibrary() {
    const baseURL = props.baseURL;
    // This is the base URL for polling the API server.
    try {
      const prompt = promptRef.current.innerText;
      const userURL = `${baseURL}/api/v1/submit_prompt`;
      const params = new URLSearchParams({
        prompt: prompt,
        user_id: userId,
      });
      const URL = `${userURL}?${params.toString()}`;
      const response = await fetch(URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prompt: prompt }),
      });
      const data = await response.json();
      const status = response.ok ? data.status : data.detail;

      if (promptRef.current.innerText !== "") {
        const videos = (
          <div className="VideoArenaApp-contents">
            <div className="VideoArenaApp-video-container">
              <div className="VideoArenaApp-video"></div>
              <h3 className="ModelLabel">Loading Model A ...</h3>
            </div>
            <div className="VideoArenaApp-video-divider"></div>
            <div className="VideoArenaApp-video-container">
              <div className="VideoArenaApp-video"></div>
              <h3 className="ModelLabel">Loading Model B ...</h3>
            </div>
            <div className="VideoArenaApp-video-prompt">
              <p>Loading ...</p>
            </div>
          </div>
        );
        props.setLibrary([
          { prompt: prompt, generation_id: data.generation_id, videos: videos },
          ...props.library,
        ]);
        props.toggle(false);
      }
    } catch {
      return;
    }
  }

  useEffect(() => {
    console.log("----- enter GeneratePage userId=", userId);
    return () => {
      console.log("----- exit GeneratePage");
    };
  }, []);

  useEffect(() => {
    userId = props.userId;
    console.log("----- update GeneratePage userId =", userId);
  }, [props.userId]);

  async function generateRandom() {
    let prompt = Math.random();
    buttonRef.current.value = prompt;
    //     const voteURL = `${baseURL}/api/v1/submit`;
    //     const params = new URLSearchParams({
    //     arena_id: currentMetadata.arena_id,
    //     vote: voteId,
    //     user_id: userId,
    //   });
    //   const URL = `${voteURL}?${params.toString()}`;

    //   const response = await fetch(URL, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
  }

  const onClick = (event) => {
    if (!boxRef.current.contains(event.target)) {
      props.toggle(false);
    }
  };

  return (
    <>
      {props.display && (
        <div className="GeneratePage" onClick={onClick}>
          <div id="generate-box" ref={boxRef}>
            <span
              className="textarea"
              role="textbox"
              contentEditable
              ref={promptRef}
            ></span>
            <div className="button-array">
              <button
                id="RandomPromptButton"
                onClick={generateRandom}
                ref={buttonRef}
              >
                <ShuffleIcon></ShuffleIcon>
                <h3>Random</h3>
              </button>
              <span className="spacer"></span>
              <button id="EnterButton" onClick={updateLibrary} ref={buttonRef}>
                <ArrowForwardIcon></ArrowForwardIcon>
              </button>
            </div>

            {/* Disclaimer Text */}
            <div style={{ color: "red", marginTop: "10px", fontSize: "12px" }}>
              We will manually select quality prompts to generate videos at a
              later time. Do not submit prompts that are illegal, harmful,
              violent, racist, or sexual in nature. Do not upload private
              information. We reserve the right to remove any prompts that
              violate our guidelines.
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default GeneratePage;
